// extracted by mini-css-extract-plugin
export default {"modalBodyCustomDuplicati":"GestioneDuplicatiComponent_modalBodyCustomDuplicati__861RC"};